import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/base-components/Icon";

export const ItemIcon: React.FC<{
  color: string;
  bgColor: string;
  icon: IconProp;
  padded?: boolean;
  isLoading?: boolean;
}> = ({ color, bgColor, icon, padded, isLoading }) => (
  <div
    className={twJoin(
      "flex h-6 w-6 items-center justify-center rounded-md bg-opacity-50",
      bgColor,
      padded && "pl-px pt-0.5",
    )}
  >
    <Icon
      color={color}
      icon={isLoading ? faCircleNotch : icon}
      size="xs"
      spin={isLoading}
    />
  </div>
);
